import React from 'react';

interface PageWrapperProps {
  children: React.ReactNode;
  variant?: 'default' | 'admin' | 'styret' | 'transparent';
  onMenuClick?: () => void;
  intro?: {
    title: string;
    description: string;
  };
  contentWidth?: 'default' | 'wide';
}

export function PageWrapper({ children, intro, variant = 'default', contentWidth = 'default' }: PageWrapperProps) {
  // Enkel wrapper uten å rendre noen header. Global Layout/StyretLayout håndterer header/footer.
  const getMarginClass = () => {
    if (variant === 'admin' || variant === 'styret') {
      // Admin/Styret sider bruker AdminLayout, så vi trenger kun mobil-marginer
      return 'mx-4 lg:mx-0';
    }
    return contentWidth === 'wide' ? 'mx-1 sm:mx-2' : 'mx-4';
  };
  
  const marginClass = getMarginClass();
  
  // For admin/styret varianter, ikke render full page wrapper siden AdminLayout håndterer det
  if (variant === 'admin' || variant === 'styret') {
    return (
      <div>
        {intro && (
          <div className="hidden sm:block text-center lg:text-left sm:max-w-3xl sm:mx-auto sm:mb-2 lg:pl-14 sm:mt-22">
            <h1 className="text-2xl font-bold font-logo lg:hidden">{intro.title}</h1>
            {intro.description && (
              <p className="text-gray-600 mt-1 lg:hidden">{intro.description}</p>
            )}
          </div>
        )}
        {children}
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-base-white">
      <main className={variant === 'transparent' ? `pt-16 ${marginClass}` : `pt-16 sm:mt-4 mt-2 ${marginClass}`}>
        {intro && (
          <div className="hidden sm:block text-center lg:text-left sm:max-w-3xl sm:mx-auto sm:mb-2 lg:pl-14 sm:mt-22">
            <h1 className="text-2xl font-bold font-logo lg:hidden">{intro.title}</h1>
            {intro.description && (
              <p className="text-gray-600 mt-1 lg:hidden">{intro.description}</p>
            )}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}